import { render, staticRenderFns } from "./OnboardingQuestions.vue?vue&type=template&id=4a1217ce"
import script from "./OnboardingQuestions.vue?vue&type=script&lang=js"
export * from "./OnboardingQuestions.vue?vue&type=script&lang=js"
import style0 from "./OnboardingQuestions.vue?vue&type=style&index=0&id=4a1217ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports